export default __webpack_public_path__ + "static/Banner1-fb80b64b8c50a6a0ca539faffdaec75d.png";